import { useContext } from 'react';

import { PremissionContext } from './permissions-context';

// ----------------------------------------------------------------------

export function usePremissionContext() {
  const context = useContext(PremissionContext);

  if (!context) throw new Error('usePremissionContext must be use inside PremissionProvider');

  return context;
}
